import { useState, useEffect, useMemo } from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListUl } from "@fortawesome/free-solid-svg-icons";
import Item from "./item";
import { useNavigate } from "react-router-dom";
import LogOut from "../../Component/LogOut/LogOut";
import imgUser from "../../Image/team-01.png";
import { useSidebar } from "../../Context/SidebarContext";
import { getDriveImageUrl } from "../../util/Driveimage";
import { clearUserSession, getUserSession } from "../../function/AuthStorage";

const menuItems = [
  {
    id: "home",
    icon: "fa-duotone fa-solid fa-chart-pie-simple",
    name: "الرئيسيه",
    link: "/home-page",
    roles: ["admin"], // Admin فقط
    adminOnly: true,
  },
  {
    id: "homee",
    icon: "fa-duotone fa-solid fa-chart-pie-simple",
    name: "الداش",
    link: "/home-pagee",
    roles: ["admin"], 
    adminOnly: true,
  },
  {
    id: "search",
    icon: "fa-light fa-chart-simple",
    name: "بحث الطلبات",
    link: "/search-requests",
    roles: ["all"],
    anyOf: [
      "Construction.View", "Emergency.View",
      "Maintenance.View", "NewProject.View", "PrivateProject.View",
    ],
  },
  {
    id: "private-projects",
    icon: "fa-light fa-building",
    name: "المشاريع الخاصة",
    link: "/all-admin-private-project",
    roles: ["all"],
    permission: "PrivateProject.View",
  },
  {
    id: "add-account",
    icon: "fa-light fa-bag-shopping",
    name: "الحسابات",
    link: "/accounts",
    roles: ["all"],
    permission: "Users.View",
  },
  // {
  //   id: "engineers",
  //   icon: "fa-light fa-user-helmet-safety",
  //   name: "المهندسين",
  //   link: "/engineers",
  //   roles: ["all"],
  //   permission: "Employees.View",
  // },
  {
    id: "branches",
    icon: "fa-solid fa-code-branch",
    name: "الافرع",
    link: "/branches",
    roles: ["all"],
    permission: "Branch.View",
  },
  {
    id: "employees",
    icon: "fa-light fa-briefcase",
    name: "العاملين",
    link: "/employees",
    roles: ["all"],
    permission: "Employees.View",
  },
  {
    id: "permissions",
    icon: "fa-light fa-shield",
    name: "اضافة صلاحيات",
    link: "/add-permission",
    roles: ["all"],
    permission: "Users.ManagePermissions",
  },
  {
    id: "offices",
    icon: "fa-solid fa-building",
    name: "المكاتب",
    link: "/offices",
    roles: ["all"],
    permission: "Office.View",
  },
  {
    id: "districts",
    icon: "fa-light fa-city",
    name: "الاحياء",
    link: "/district",
    roles: ["all"],
    permission: "Neighborhood.View",
  },
  {
    id: "consultants",
    icon: "fa-light fa-user-tie",
    name: "الاستشاريون",
    link: "/consultants",
    roles: ["all"],
    permission: "Consultant.View",
  },
  {
    id: "project-owners",
    icon: "fa-light fa-user",
    name: "ملاك المشاريع",
    link: "/project-owners",
    roles: ["all"],
    permission: "ProjectOwner.View",
  },
  {
    id: "project-parties",
    icon: "fa-light fa-building",
    name: "جهات المشاريع",
    link: "/project-parties",
    roles: ["all"],
    permission: "ProjectParty.View",
  },
  {
    id: "accept-requests",
    icon: "fa-solid fa-check-circle",
    name: "قبول الطلبات",
    link: "/accept-requests",
    roles: ["all"],
    anyOf: [
      "Construction.Approve", "Emergency.Approve",
      "Maintenance.Approve", "NewProject.Approve", "PrivateProject.Approve",
    ],
  },
  {
    id: "delete-requests",
    icon: "fa-solid fa-trash",
    name: "طلبات الحذف",
    link: "/accept-delete",
    roles: ["all"],
    anyOf: [
      "Construction.Delete", "Emergency.Delete",
      "Maintenance.Delete", "NewProject.Delete", "PrivateProject.Delete",
    ],
  },
  {
    id: "custodies",
    icon: "fa-solid fa-box",
    name: "العهد",
    link: "/custodies",
    roles: ["all"],
    permission: "Custody.View",
  },
  {
    id: "notifications",
    icon: "fa-light fa-bell",
    name: "الاشعارات",
    link: "/notification",
    roles: ["all"],
    permission: "Notifications.View",
  },
  {
    id: "vacations",
    icon: "fa-light fa-calendar-check",
    name: "الإجازات",
    link: "/vacations",
    roles: ["all"],
    permission: "LeaveRequest.View",
  },
  {
    id: "check-attendance",
    icon: "fa-light fa-check-circle",
    name: "تسجيل الحضور",
    link: "/check-attendance",
    roles: ["all"],
    permission: "Attendance.View",
  },
  {
    id: "task-type",
    icon: "fa-light fa-briefcase",
    name: "نوع أمر العمل",
    link: "/tasktype",
    roles: ["all"],
    permission: "WorkOrderType.View",
  },
  {
    id: "trash",
    icon: "fa fa-trash",
    name: "سلة المهملات",
    link: "/deleted-projects",
    roles: ["all"],
    anyOf: [
      "Construction.Delete", "Emergency.Delete",
      "Maintenance.Delete", "NewProject.Delete", "PrivateProject.Delete",
    ],
  },
  // ✅ جديد: عنصر الملف الشخصي - متاح لأي مستخدم مسجل دخول، من غير شرط صلاحية
  {
    id: "profile",
    icon: "fa-light fa-id-card",
    name: "الملف الشخصي",
    link: "/profile",
    roles: ["all"],
  },
];

function getUserPermissions() {
  const user = getUserSession();
  return user?.permissions || [];
}

// ─── Helper: يتحقق هل المستخدم عنده الـ permission ──────────────────────
function checkPermission(item, userPerms, isAdmin, userRole) {
  // adminOnly → admin فقط
  if (item.adminOnly) return isAdmin;

  // admin يشوف كل حاجة
  if (isAdmin) return true;

  // ❌ شيل السطر ده
  // if (userRole === "supervisor") return true;

  // عنصر من غير أي شرط صلاحية (زي الملف الشخصي) → يظهر للجميع
  if (!item.permission && !item.anyOf) return true;

  // باقي الـ roles → تحقق من الـ permissions
  if (item.permission) return userPerms.includes(item.permission);

  if (item.anyOf?.length > 0) return item.anyOf.some((p) => userPerms.includes(p));

  return false;
}

function Sidebar() {
  const navigate = useNavigate();
  const { open, toggle } = useSidebar(); 
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  const cookieValue = useMemo(() => {
   return getUserSession() || {};
  }, []);

  const userRole = cookieValue.userType || "";
  const isAdmin = userRole === "admin";
  const userPerms = useMemo(() => getUserPermissions(), []);


  const userImageSrc = useMemo(
    () => getDriveImageUrl(cookieValue.userImage) || imgUser,
    [cookieValue.userImage]
  );

  const handleLogoutClick = () => setLogoutDialogOpen(true);

  const functionLogout = () => {
     clearUserSession();
     localStorage.clear();
     navigate("/");
  };

  const filteredMenuItems = useMemo(() => {
    return menuItems.filter((item) => {
      const roleOk = item.roles.includes("all") || item.roles.includes(userRole);
      if (!roleOk) return false;
      return checkPermission(item, userPerms, isAdmin, userRole);
    });
  }, [userRole, userPerms, isAdmin]);

  const sideContainerVariants = {
    true:  { width: "13rem" },
    false: { width: "5rem", transition: { delay: 0.6 } },
  };
  const sidebarVariants = {
    true:  { width: "200px" },
    false: { width: "5rem", transition: { delay: 0.4 } },
  };

  return (
    <>
      <motion.div
        data-open={open}
        variants={sideContainerVariants}
        initial={`${open}`}
        animate={`${open}`}
        className="fixed top-0 right-0 h-screen z-[1001]"
      >
        <motion.div
          initial={`${open}`}
          animate={`${open}`}
          variants={sidebarVariants}
          className="flex flex-col w-full h-full box-border p-4 m-0 bg-mainColor text-white backdrop-blur-md border border-white/20 [direction:rtl] transition-[width] duration-300 ease-in-out overflow-hidden"
        >
          <motion.div
            whileHover={{
              scale: 1.2, rotate: 180,
              backgroundColor: "rgba(255, 255, 255, 0.3)",
              backdropFilter: "blur(3.5px)",
              border: "1px solid rgba(255, 255, 255, 0.18)",
              transition: { delay: 0.2, duration: 0.4 },
            }}
            onClick={toggle}
            className="flex self-end cursor-pointer mb-5 text-xl rounded-md shrink-0"
          >
            <FontAwesomeIcon icon={faListUl} />
          </motion.div>

          <div className="flex flex-col w-full flex-1 overflow-y-auto overflow-x-hidden min-h-0">
            {filteredMenuItems.map((item) => (
              <Item key={item.id} id={item.id} icon={item.icon} name={item.name} link={item.link} />
            ))}
            {userRole === "officeManager" && (
              <Item id="office-manager" icon="fa-light fa-user-tie" name="مدير المكتب" link="/manager-profile" />
            )}
          </div>

          {cookieValue && (
            <motion.div
              className={`bg-white text-mainColor rounded-xl transition-all duration-300 w-full shrink-0 mt-2 flex items-center
                ${open ? "p-3 opacity-100" : "p-1.5 opacity-0 pointer-events-none h-0 overflow-hidden"}`}
            >
              <img
                src={userImageSrc}
                alt="User"
                onError={(e) => { e.currentTarget.src = imgUser; }}
                className="w-10 h-10 rounded-full mr-2.5 shrink-0 object-cover"
              />
              <div className="text-right whitespace-normal break-words min-w-0 flex-1">
                <h4 className="m-0 text-sm whitespace-normal break-words">{cookieValue.userName}</h4>
                <p className="m-0 text-xs text-gray-500 ">{cookieValue.email}</p>
              </div>
            </motion.div>
          )}

          {cookieValue && (
            <button
              onClick={handleLogoutClick}
              className={`bg-white/10 text-white border border-white/20 rounded-md cursor-pointer transition-colors duration-300 hover:bg-secondaryColor shrink-0 w-full mt-2
                ${open ? "text-sm px-4 py-2" : "text-[8px] px-1 py-2"}`}
            >
              {open ? "تسجيل الخروج" : "خروج"}
            </button>
          )}
        </motion.div>
      </motion.div>

      <LogOut open={logoutDialogOpen} onClose={() => setLogoutDialogOpen(false)} onConfirm={functionLogout} />
    </>
  );
}

export default Sidebar;